import React from 'react';

export default function PriorityEnrollmentModalContent() {
  return (
    <p>
      If a college or university has a system for priority enrollment that
      allows certain student Veterans to enroll in courses earlier than other
      students (not necessarily earlier than all students), we’ll note that with
      the school’s information here.
    </p>
  );
}
